export default __webpack_public_path__ + "static/media/bizChrono.9b3b0d34.png";